import { useLocation } from "react-router-dom";
import { Menu, Search } from "lucide-react";
import { PAGE_TITLES } from "../../dashboard/nav";
import { NotificationCenter } from "./NotificationCenter";
import { WalletPill } from "./WalletPill";

export const Topbar = ({ onMenu }) => {
    const { pathname } = useLocation();
    const title = PAGE_TITLES[pathname] || "Dashboard";

    return (
        <header
            className="sticky top-0 z-30 border-b border-white/5 bg-nx-ink/90 backdrop-blur-lg"
            data-testid="dashboard-topbar"
        >
            <div className="mx-auto flex h-16 max-w-[1400px] items-center gap-3 px-4 sm:px-6 lg:px-8">
                <button
                    type="button"
                    onClick={onMenu}
                    data-testid="dashboard-menu-button"
                    aria-label="Open menu"
                    className="flex h-9 w-9 items-center justify-center rounded-lg border border-white/10 bg-nx-elev text-nx-text lg:hidden"
                >
                    <Menu size={16} strokeWidth={1.5} aria-hidden="true" />
                </button>

                <div className="min-w-0">
                    <p className="hidden text-[10px] font-bold uppercase tracking-[0.2em] text-nx-mute sm:block">
                        Nexora <span className="mx-1 text-nx-mute/50">/</span> {title}
                    </p>
                    <h1 className="truncate text-sm font-extrabold tracking-wide text-nx-text sm:text-base" data-testid="page-title">
                        {title}
                    </h1>
                </div>

                <div className="mx-auto hidden w-full max-w-sm items-center md:flex">
                    <label className="relative w-full">
                        <Search size={14} strokeWidth={1.5} className="pointer-events-none absolute left-3 top-1/2 -translate-y-1/2 text-nx-mute" aria-hidden="true" />
                        <input
                            type="search"
                            placeholder="Search wallet, ID, transaction..."
                            data-testid="dashboard-search"
                            className="h-9 w-full rounded-lg border border-white/5 bg-nx-alt pl-9 pr-3 text-xs font-medium text-nx-text placeholder:text-nx-mute/70 focus:border-nx-lime/40 focus:outline-none"
                        />
                    </label>
                </div>

                <div className="ms-auto flex items-center gap-2.5">
                    <NotificationCenter />
                    <WalletPill />
                    <span
                        className="hidden h-9 w-9 items-center justify-center rounded-full border border-white/10 bg-nx-elev text-[10px] font-extrabold tracking-wider text-nx-text sm:flex"
                        data-testid="profile-avatar"
                        aria-label="Account"
                    >
                        NX
                    </span>
                </div>
            </div>
        </header>
    );
};
